export const AppConfig =
{
  company: "The Healthy Employee",
  email: "healthcarepractitioner@thehealthyemployee.co.uk",
  web: "https://www.thehealthyemployee.co.uk",
  tel: "07778218009",
  signature: "The Healthy Employee Team",
  preAssessment: true,
  preAssessmentUri: "https://thehealthyemployee.prescreening.apps.welltechsolutions.co.uk/"
};